import React, { useContext, useEffect, useState } from 'react';
import {IProps} from './types';
import Tooltip from '@components/Tooltip';
import * as S from './styles';
import {ITextAttributes} from 'routes/private/Editor/types';
import { Context } from "routes/private/Editor/Context";
import { findElementById, findCommonAttributeValue } from "@utils/editor";
import {ReactComponent as ItalicIcon} from 'assets/svgs/italic.svg';

const FontItalicComandOption : React.FC<IProps> = () => {
  let context = useContext(Context);
  const [isSelected, setIsSelected]= useState(false);

  useEffect(() => {
    const fontItalic = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "fontItalic", "Text", context.editorStatus.textSelectionInformation);
    const someOneNotItalic = !fontItalic;
    setIsSelected(!someOneNotItalic);
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data, context.editorStatus.textSelectionInformation]);

  const SetFontItalic = () => {  
    setIsSelected(!isSelected);
    context.onCommandChange("fontItalic", !isSelected);          
  }

  return (
    <S.Root>
      <Tooltip tip={"Italic"}>
        <S.ButtonContainer onClick={SetFontItalic} isSelected={isSelected}>
            <ItalicIcon/>
        </S.ButtonContainer>
      </Tooltip>
    </S.Root>
  );
}

export default FontItalicComandOption;